import React from 'react';
import FeatureCard from './FeatureCard';
import './Features.css';
import playbookImage from '../images/playbook-builder.png';
import taskListImage from '../images/task-list.png';
import budgetImage from '../images/budget-roi.png';
import aiStrategyImage from '../images/ai-strategy.png';

function Features() {
  return (
    <section className="features">
      <div className="features-container">
        <h2 className="features-heading">Why Zibit?</h2>
        <div className="features-grid">
          <FeatureCard 
            image={playbookImage}
            title="Playbook Builder"
            description="Plan smarter with goal-based strategies and exhibitor insights"
          />
          <FeatureCard 
            image={taskListImage}
            title="Task List"
            description="From logistics to post-show follow-up, everything lives in Zibit"
          />
          <FeatureCard 
            image={budgetImage}
            title="Budget & ROI Calculator"
            description="Instantly evaluate performance with cost-per-lead benchmarks"
          />
          <FeatureCard 
            image={aiStrategyImage}
            title="AI-Enhanced Guided Strategy"
            description="Keep marketing, sales, and ops aligned with real-time updates"
          />
        </div>
      </div>
    </section>
  );
}

export default Features;